// @ts-nocheck
import Profile from "./Profile";

/**
 * The Profile page: the profile details, plus an Activity card that lists the user's recent Support
 * Copilot activity (the activity recorded in Salesforce). The old Ask AI source — the previous RAG's
 * conversation history — is gone (ACOP-152), so there is nothing to choose between.
 */
const SearchHistory = ({ isShowRecentHistory, handleHistoryClick, setChatRecentHistory, chatRecentHistoryAll, chatRecentHistory, setIsShowMore, isShowMore, roles }) => {

    const formatDate = (date) => {
      var d = new Date(date);
      return d.toLocaleString([], { hour12: true});
    }

    const handleShowMore = () => {
        setChatRecentHistory(chatRecentHistoryAll);
        setIsShowMore(false);
    }

    return(
        <div className={`recent-section pt-0 ${isShowRecentHistory ? '' : 'd-none'}`}>
            <Profile roles={roles} />
            <div className="container-fluid py-3 px-3 copilot-changelog">
                <div className="copilot-changelog-card mb-3">
                    <div className="copilot-changelog-card__accent copilot-changelog-card__accent--muted" aria-hidden />
                    <div className="copilot-changelog-card__body">
                        <h2 className="copilot-changelog-section-title">Activity</h2>
                        <p className="copilot-changelog-section-lead">
                            Load recent Support Copilot activity.
                        </p>
                        <button
                            type="button"
                            className="btn btn-primary login-form-submit"
                            data-testid="profile-activity-load-btn"
                            onClick={() => handleHistoryClick()}
                        >
                            Load activity
                        </button>
                    </div>
                </div>
            </div>
            {chatRecentHistory && chatRecentHistory.length > 0 && (
                <div className="mt-3 px-3 copilot-changelog">
                    {chatRecentHistory.map((chat, index) => (
                        <div key={index} className="card history-item mb-2" data-testid="profile-activity-row">
                            <div className='card-body pt-2 pb-1'>
                                <div className="row">
                                    <div className="col-1">
                                        <i className="fa-solid fa-user"></i>
                                    </div>
                                    <div className="col-7">
                                        <h6 className="text-muted">
                                            <b>{chat.activity}</b>
                                        </h6>
                                    </div>
                                    <div className="col-4">
                                        {chat.date_time && <p className="chat-time">{formatDate(chat.date_time)}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {isShowMore && (
                        <div className="row mt-1">
                            <div className="col-6"></div>
                            <div className="col-6 clearfix">
                                <button
                                    className="me-2 float-end text-decoration-none"
                                    style={{cursor: 'pointer'}}
                                    data-testid="profile-activity-show-more-btn"
                                    onClick={() => handleShowMore()}
                                >
                                    Show More
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default SearchHistory;
